import { GuidedTour, Orientation } from "ngx-guided-tour";

export const newPlanTour: GuidedTour = {
    tourId: 'newPlan',
    useOrb: false,
    steps: [
        {
            title: '  ',
            content: `
                <img src="assets/undraw/hello.svg" class="w-100 undraw">
                <br />
                <h5 class="w-100 my-3 text-center">
                    Primeiro Passo:
                </h5>
                Selecionar para qual <strong>prova</strong> ou <strong>concurso</strong> você pretende estudar. Vou te mostrar como fazer!
            `
        },
        {
            title: 'Criar Plano',
            selector: '.all-filters',
            content: 'Use os <strong>filtros</strong> para encontrar sua prova ou seu concurso.',
            orientation: Orientation.Bottom,
            highlightPadding: 15
        },
        {
            title: 'Criar Plano',
            selector: '.edicts-search',
            content: 'Selecione a prova ou concurso para o qual está estudando. <strong>Você pode escolher mais de uma opção</strong>.',
            orientation: Orientation.Top,
            highlightPadding: 15
        },
        {
            title: 'Criar Plano',
            selector: '.edicts-search>.card:nth-child(1)',
            content: 'Caso não encontre seu concurso, não se preocupe, você <strong>poderá adicionar suas disciplinas manualmente</strong>.',
            orientation: Orientation.Top,
            highlightPadding: 15
        }
    ]
};

export const detailPlanTour: GuidedTour = {
    tourId: 'detailPlan',
    useOrb: false,
    steps: [
        {
            content: `
                <p class="text-center mt-2">Aee! Seu primeiro <strong>plano</strong> foi criado!</p>
                <img src="assets/undraw/completing.svg" class="w-50 undraw d-flex mx-auto">
                <p class="text-center mt-3 mb-0">Vamos aos próximos passos.</p>
            `
        },
        {
            title: 'Disciplinas',
            selector: '.subjects',
            content: 'Essas são as disciplinas adicionadas ao seu Plano. Você pode editá-las se quiser.',
            orientation: Orientation.Top,
            highlightPadding: 0
        },
        {
            title: 'Disciplinas',
            selector: '.id>div',
            content: 'As siglas indicam de quais concursos veio cada disciplina.',
            orientation: Orientation.Right,
            highlightPadding: 15
        },
        {
            title: 'Disciplinas',
            selector: '.btn-outline-primary',
            content: 'Você também pode adicionar novas disciplinas ao seu plano se quiser.',
            orientation: Orientation.Bottom,
            highlightPadding: 15
        }
    ]
};